<template>
  <div>
    <div class="title whiteBox">{{ $t('view.密码修改') }}</div>
    <div class="whiteBox">
      <el-form ref="form" :model="form" label-width="80px" style="width: 90%;margin: 20px auto; " :rules="rules">
        <el-form-item :label="$t('view.旧密码')" prop="oldPassword">
          <el-input size="mini" style="width: 280px" v-model="form.oldPassword" :placeholder="$t('view.请输入')+$t('view.旧密码')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('view.新密码')" prop="newPassword">
          <el-input size="mini" style="width: 280px" v-model="form.newPassword" :placeholder="$t('view.请输入')+$t('view.新密码')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('view.确认密码')" prop="confirmPassword">
          <el-input size="mini" style="width: 280px" v-model="form.confirmPassword" :placeholder="$t('view.请输入')+$t('view.确认密码')"></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: center;">
        <el-button size="mini" type="primary" @click="profileUpdatePwd">{{ $t('view.保存') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {profileUpdatePwd} from '@/api/login'

export default {
  data() {
    const equalToPassword = (rule, value, callback) => {
      if (this.form.newPassword !== value) {
        callback(new Error(this.$t('view.密码不一致')));
      } else {
        callback();
      }
    };
    return {
      rules: {
        oldPassword: [{required: true, trigger: 'blur', message: this.$t('view.请输入')}],
        newPassword: [{required: true, trigger: 'blur', message: this.$t('view.请输入')}],
        confirmPassword: [
          {required: true, message: this.$t('view.请输入'), trigger: "blur"},
          {required: true, validator: equalToPassword, trigger: "blur"}
        ]
      },
      form: {}
    }
  },
  methods: {
    profileUpdatePwd() {
      this.$refs.form.validate(valid => {
        if (valid) {
          profileUpdatePwd(this.form).then(res => {
            if (res.code == 200) {
              this.$message.success(this.$t('view.修改成功'))
              // this.$store.dispatch("LogOut").then(res=>{
              //     this.$router.push('/')
              // })
            }
          })
        }
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.title {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
}
</style>
